import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { submitLogoutFlow, useCreateLogoutFlow } from '@web-apps/feature-auth'
import { Box, Flex, LoadingIndicator, Typography } from '@web-apps/ui-shared'

import { clearImpersonatedZezamId } from '../../utils/helpers/impersonation.helpers'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 100vh;
  text-align: center;
`

const StyledSupportLink = styled.a`
  color: inherit;
`

export const NoAccess = () => {
  const { t } = useTranslation(['app'])
  const supportEmail = t('app:no_access.support_email')

  const { token, isLoading, error } = useCreateLogoutFlow()
  const [isLoggedOut, setIsLoggedOut] = useState(false)

  useEffect(() => {
    if (isLoggedOut) return

    if (error || (!isLoading && !token)) {
      setIsLoggedOut(true)
      return
    }

    if (!token) return

    const logOut = async () => {
      localStorage.removeItem('isSeamlessAuth')
      clearImpersonatedZezamId()
      await submitLogoutFlow({ token })
      setIsLoggedOut(true)
    }

    logOut()
  }, [token, isLoading, error, isLoggedOut])

  if (!isLoggedOut) return <LoadingIndicator size={100} isCentered />

  return (
    <StyledContainer>
      <Box my={64} px={24}>
        <Flex gap={16} direction="column" align="center">
          <Typography variant="h2" fontWeight="600">
            {t('app:no_access.title')}
          </Typography>
          <Typography>
            {t('app:no_access.description')}{' '}
            <StyledSupportLink href={`mailto:${supportEmail}`}>
              {supportEmail}
            </StyledSupportLink>
          </Typography>
        </Flex>
      </Box>
    </StyledContainer>
  )
}
